import type AppSignal from '@appsignal/javascript';
import { captureException } from './.client/sentry';
import { userStore } from './stores/user';
import { loadAppSignal } from '~/lib/appsignal';
import { APPSIGNAL_KEY } from '~/lib/constants';
import { logger } from '~/utils/logger';

const appSignalPromise = import.meta.env.DEV ? null : loadAppSignal(APPSIGNAL_KEY, 'frontend');

if (APPSIGNAL_KEY) {
  Promise.all([appSignalPromise, import('@appsignal/plugin-window-events')]).then(([appSignal, { plugin }]) => {
    appSignal?.use(plugin());

    appSignal?.addDecorator((span) => {
      const username = userStore.getUser()?.username;

      if (username) {
        span.setTags({ username });
      }

      span.setTags({ url: window.location.href });

      return span;
    });
  });
}

export type Breadcrumb = Parameters<AppSignal['addBreadcrumb']>[0];

export function addBreadcrumb(breadcrumb: Breadcrumb) {
  appSignalPromise?.then((appSignal) => {
    appSignal.addBreadcrumb(breadcrumb);
  });
}

export async function sendAppSignalError(originalError: unknown) {
  try {
    const error = originalError instanceof Error ? originalError : new Error(`${originalError}`);

    if (import.meta.env.DEV) {
      logger.info(`Sending to AppSignal\n\n${error}`);
      return;
    }

    captureException(originalError);

    const appSignal = await appSignalPromise;

    await appSignal?.sendError(error, (span) => {
      if (import.meta.env.MODE === 'production') {
        span.setParams({ ...error });
      }
    });
  } catch {
    // let's not crash the app for now
  }
}
